import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";

export default function ConfirmFinishOrderPickingModal({ open, onClose, onConfirm }) {

  const handleConfirm = () => {
    // Remove picked up product
    onConfirm()
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Finish order</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You cannot revert this change. Please ensure the products are correct before to confirm this order as finish
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          color="primary"
        >
          Finish Order
        </Button>
      </DialogActions>
    </Dialog>
  );
}